import { HyperLinkRedirectControlPatientProfileSubTabs } from "@/Common/Components/Buttons/HyperLinkRedirectControl";
import { InformationLoadingComponent } from "@/Common/Components/Loader/InformationLoadingComponent";
import { AccountDetails as AccountDetailsV2, IAccountDetails } from "@/Common/Components/Portal/InvitationPopup/AccountDetails/AccountDetails";
import { InvitationPopup } from "@/Common/Components/Portal/InvitationPopup/InvitationPopup";
import { AccountDetails } from "@/Common/Components/Portal/Management/AccountDetails";
import { AccountRecentActivity } from "@/Common/Components/Portal/Management/AccountRecentActivity";
import { AccountUserLinked } from "@/Common/Components/Portal/Management/AccountUserLinked";
import { AccountUserSharing } from "@/Common/Components/Portal/Management/AccountUserSharing";
import { PatientMessaging } from "@/Common/Components/Portal/Management/PatientMessaging";
import { RelinkPortalAccountPopup } from "@/Common/Components/Portal/Management/RelinkPortalAccountPopup";
import { SubscriptionDetails } from "@/Common/Components/Portal/Management/SubscriptionDetails";
import { SubscriptionPaymentInformation } from "@/Common/Components/Portal/Management/SubscriptionPaymentInformation";
import { SubscriptionTransactionHistory } from "@/Common/Components/Portal/Management/SubscriptionTransactionHistory";
import { SubscriptionUserManagement } from "@/Common/Components/Portal/Management/SubscriptionUserManagement";
import { Patient } from "@/Common/Models/Patient/Patient";
import { ProfileTab } from "@/Common/Models/Patient/PatientEnums";
import { IPatientPortalProfileManagementModel } from "@/Common/Models/Patient/UI/Profile/IPatientPortalProfileManagementModel";
import { Person } from "@/Common/Models/Person/Person";
import { GetPatientOverviewResponse } from "@/Common/Models/Portal/MedfarPortal";
import { RedirectTo } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { LinkButton } from "@/DesignSystem";

import styles from "./PortalManagement.module.scss";

interface IPortalSubscriptionManagementProp {
    patientInfo: Patient;
    patientId: string;
    profileModel: IPatientPortalProfileManagementModel;
    accountDetailsV2?: IAccountDetails;
}

class PortalSubscriptionManagementState {
    public isLoading: boolean = true; // set to true so first render sees that
    public isResending: boolean = false;
    public isRelinkingWithNewFlow: boolean = false;
}

class PortalManagement extends React.Component<IPortalSubscriptionManagementProp, PortalSubscriptionManagementState> {
    constructor(props: IPortalSubscriptionManagementProp) {
        super(props);

        this.state = new PortalSubscriptionManagementState();
    }

    public static getDerivedStateFromProps(nextProps: IPortalSubscriptionManagementProp, prevState: PortalSubscriptionManagementState): PortalSubscriptionManagementState {
        if (cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 ? (nextProps.accountDetailsV2 && nextProps.profileModel.get("PatientProfileOverview")) : nextProps.profileModel.get("PatientProfileOverview")) {
            $(window).trigger("resize");
            return {
                ...prevState,
                isLoading: false
            };
        }
        return null;
    }

    public render(): JSX.Element {
        if (this.state.isLoading) {
            return (
                <InformationLoadingComponent cssClass="top-pad-100" customMessage={cacheStore.GetString("LoadPortalInfoLabel")} />
            );
        }
        else {
            let portalPatientOverview: GetPatientOverviewResponse = this.props.profileModel.get("PatientProfileOverview");

            let isSubscriptionEnabled = cacheStore.portalConfiguration?.HasSubscriptions;

            let subscriptionDetails: JSX.Element = isSubscriptionEnabled &&
                <SubscriptionDetails subscription={portalPatientOverview?.Subscription} patientContactId={this.props.patientId} />;

            let paymentMethods: JSX.Element = isSubscriptionEnabled &&
                <SubscriptionPaymentInformation paymentGatewayCustomer={portalPatientOverview?.PaymentCustomer} patientContactId={this.props.patientId} subscription={portalPatientOverview?.Subscription} />;

            let transactionHistory: JSX.Element = isSubscriptionEnabled &&
                <SubscriptionTransactionHistory subscription={portalPatientOverview?.Subscription} patientContactId={this.props.patientId} />;

            let subscriptionMembers: JSX.Element = isSubscriptionEnabled &&
                <SubscriptionUserManagement subscription={portalPatientOverview?.Subscription} patientContactId={this.props.patientId} />;

            const shouldDisplayGrantsAccessToSection = portalPatientOverview?.LinkedAccounts?.filter(p => !p.IsOwner).any();

            return (
                <div className="patient-prof">
                    <div className="scrollable">
                        <div className="portal-mgmt-layout">
                            <AccountRecentActivity patientContactId={this.props.patientId} />
                            <div className="portal-account">

                                {portalPatientOverview && (
                                    <>
                                        {cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 ? (
                                            <>
                                                <div className="centered block separated psingle-column wider">
                                                    <AccountDetailsV2
                                                        username={this.props.accountDetailsV2?.username}
                                                        status={this.props.accountDetailsV2?.status}
                                                        refusalDate={new Date(this.props.accountDetailsV2?.refusalDate)}
                                                        lastLoginDate={new Date(this.props.accountDetailsV2?.lastLoginDate)}
                                                        lastInvitationDate={new Date(this.props.accountDetailsV2?.lastInvitationDate)}
                                                        lastLoginAttemptDate={new Date(this.props.accountDetailsV2?.lastLoginAttemptDate)}
                                                        isPopup={false}
                                                        onResendInvitation={() => {
                                                            this.setState({ isResending: true });
                                                        }}
                                                        onRelink={() => {
                                                            this.setState({ isRelinkingWithNewFlow: true });
                                                        }}
                                                    />
                                                </div>
                                                {cacheStore.ClinicSettings.EnableBidirectionalCommunication && (
                                                    <div className="centered separated psingle-column wider">
                                                        {this.renderPatientMessaging()}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <AccountDetails
                                                    patientInfo={this.props.patientInfo}
                                                    overview={portalPatientOverview}
                                                    patientContactId={this.props.patientId}
                                                    isEmailChangeDisabled={false}
                                                />
                                                {cacheStore.ClinicSettings.EnableBidirectionalCommunication && (
                                                    this.renderPatientMessaging()
                                                )}
                                            </>
                                        )
                                        }
                                    </>
                                )}

                                {portalPatientOverview?.Account && !cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 && (
                                    <AccountUserSharing
                                        portalUser={portalPatientOverview.Account}
                                        patientContactId={this.props.patientId}
                                    />
                                )}

                                {shouldDisplayGrantsAccessToSection && !cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 && (
                                    <AccountUserLinked
                                        portalUsers={portalPatientOverview.LinkedAccounts}
                                        showHeader={true}
                                    />
                                )}

                                {cacheStore.ClinicSettings.EnablePortalInvitationFlowV2 && (
                                    <div className="centered block separated psingle-column wider">
                                        <div className="flex-container heading">
                                            <h3 className="thin-font">
                                                {cacheStore.GetString("AccessRightsLabel")}
                                            </h3>
                                        </div>
                                        <div className="flex-container center padding-bottom-10">
                                            <p>
                                                {cacheStore.GetString("PortalInvitation_AccessRightsMovedMessageLabel")
                                                    .split("{{relations}}")[0]
                                                }
                                                <LinkButton
                                                    dataCy="relations-link"
                                                    label={cacheStore.GetString("RelationsLabel")}
                                                    onClick={() => {
                                                        sessionStore.dispatch(LocalOperations.Misc.RedirectToTab, {
                                                            currentLocation: RouterHistory.location,
                                                            value: this.props.patientInfo?.IndividualResponse?.Contact_id,
                                                            target: RedirectTo.Patient,
                                                            navigateToSubTab: new HyperLinkRedirectControlPatientProfileSubTabs(ProfileTab.Relationships)
                                                        });
                                                    }}
                                                />
                                                {cacheStore.GetString("PortalInvitation_AccessRightsMovedMessageLabel")
                                                    .split("{{relations}}")[1]
                                                }
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {subscriptionDetails}
                                {paymentMethods}
                                {transactionHistory}
                                {subscriptionMembers}
                            </div>
                        </div>
                    </div>
                    {this.state.isResending && (
                        <InvitationPopup
                            person={Person.FromPatient(this.props.patientInfo)}
                            onCancel={() => {
                                this.setState({ isResending: false });
                            }}
                            skipLockedStatusNote={true}
                        />
                    )}
                    {this.state.isRelinkingWithNewFlow && (
                        <RelinkPortalAccountPopup
                            patientInfo={this.props.patientInfo}
                            patientContactId={this.props.patientInfo?.IndividualResponse?.Contact_id}
                            componentId="patientPortal_sub_linkMemberAccount"
                            onCloseCallback={() => {
                                this.setState({ isRelinkingWithNewFlow: false });
                            }}
                        />
                    )}
                </div>
            );
        }
    }

    private renderPatientMessaging(): JSX.Element {
        return (
            <div className={`block ${styles.patientMessaging}`}>
                <PatientMessaging
                    patientContactId={this.props.patientId}
                    headerLabel={cacheStore.GetString("MessagingLabel")}
                    messagesLimitLabel={cacheStore.GetString("SharedItem_MessagesAvailableLabel")}
                    alignBlockedReason
                    highlightContent
                />
            </div>
        );
    }
}

export { PortalManagement };
